<div class="main">
    <div class="padding">
        <!-- Anura -->
        <div>
            <div fxLayout="row">
                <div class="black_header" style="width: max-content;padding-inline: 10px;">
                    <h2 class="black_header_title display-flex">Anura Kumara Dissanayake</h2>
                </div>
            </div>
            <div fxLayout="row" fxLayoutGap="10" fxLayout.sm="column" fxLayout.xs="column">

                <div fxFlex="33" fxFlex.xs="100" fxFlex.sm="100" fxLayout="column">
                    <a href="https://cdn.newsfirst.lk/election/manifesto/Npp.pdf" target="_blank">
                        <img style="width: 100%;" src="https://cdn.newsfirst.lk/election/manifesto/npp_s.png" alt="">
                        <div style="text-align: center;">
                            <button class="download_btn" mat-stroked-button>Download</button>
                        </div>
                    </a>
                </div>
                <!-- <div fxFlex="33" fxFlex.xs="100" fxFlex.sm="100" fxLayout="column">
                    <a href="https://cdn.newsfirst.lk/election/manifesto/Npp.pdf" target="_blank">
                        <img style="width: 100%;"
                            src="https://cdn.newsfirst.lk/election/manifesto/Screenshot%20from%202024-08-29%2017-58-15.jpg"
                            alt="">
                        <div style="text-align: center;">
                            <button class="download_btn" mat-stroked-button>Download</button>
                        </div>
                    </a>
                </div> -->
                <div fxFlex="33" fxFlex.xs="100" fxFlex.sm="100" fxLayout="column">
                    <a href="https://cdn.newsfirst.lk/election/manifesto/NPP_Tamil.pdf" target="_blank">
                        <img style="width: 100%;" src="https://cdn.newsfirst.lk/election/manifesto/npp_t.png" alt="">
                        <div style="text-align: center;">
                            <button class="download_btn" mat-stroked-button>Download</button>
                        </div>
                    </a>
                </div>
            </div>
        </div>

        <!-- Ranil -->
        <div style="margin-top: 10px;">
            <div fxLayout="row">
                <div class="black_header" style="width: max-content;padding-inline: 10px;">
                    <h2 class="black_header_title display-flex">Ranil Wickremesinghe</h2>
                </div>
            </div>
            <div fxLayout="row" fxLayoutGap="10" fxLayout.sm="column" fxLayout.xs="column">

                <div fxFlex="33" fxFlex.xs="100" fxFlex.sm="100" fxLayout="column">
                    <a href="https://cdn.newsfirst.lk/election/manifesto/Ranil_manifesto.pdf" target="_blank">
                        <img style="width: 100%;" src="https://cdn.newsfirst.lk/election/manifesto/ranil_s.png" alt="">
                        <div style="text-align: center;">
                            <button class="download_btn" mat-stroked-button>Download</button>
                        </div>
                    </a>
                </div>
                <!-- <div fxFlex="33" fxFlex.xs="100" fxFlex.sm="100" fxLayout="column">
                    <a href="https://cdn.newsfirst.lk/election/manifesto/Npp.pdf" target="_blank">
                        <img style="width: 100%;"
                            src="https://cdn.newsfirst.lk/election/manifesto/Screenshot%20from%202024-08-29%2017-58-15.jpg"
                            alt="">
                        <div style="text-align: center;">
                            <button class="download_btn" mat-stroked-button>Download</button>
                        </div>
                    </a>
                </div> -->
                <!-- <div fxFlex="33" fxFlex.xs="100" fxFlex.sm="100" fxLayout="column">
                    <a href="https://cdn.newsfirst.lk/election/manifesto/Npp.pdf" target="_blank">
                        <img style="width: 100%;" src="https://cdn.newsfirst.lk/election/manifesto/Ranil_manifesto_tamil.pdf" alt="">
                        <div style="text-align: center;">
                            <button class="download_btn" mat-stroked-button>Download</button>
                        </div>
                    </a>
                </div> -->
            </div>
        </div>

        <!-- Sajith -->
        <div style="margin-top: 10px;">
            <div fxLayout="row">
                <div class="black_header" style="width: max-content;padding-inline: 10px;">
                    <h2 class="black_header_title display-flex">Sajith Premadasa</h2>
                </div>
            </div>
            <div fxLayout="row" fxLayoutGap="10" fxLayout.sm="column" fxLayout.xs="column">

                <div fxFlex="33" fxFlex.xs="100" fxFlex.sm="100" fxLayout="column">
                    <a href="https://cdn.newsfirst.lk/election/manifesto/Sajith_manifesto_sinhala.pdf" target="_blank">
                        <img style="width: 100%;" src="https://cdn.newsfirst.lk/election/manifesto/sajith_s.png" alt="">
                        <div style="text-align: center;">
                            <button class="download_btn" mat-stroked-button>Download</button>
                        </div>
                    </a>
                </div>
                <div fxFlex="33" fxFlex.xs="100" fxFlex.sm="100" fxLayout="column">
                    <a href="https://cdn.newsfirst.lk/election/manifesto/Sajith_manifesto_english.pdf" target="_blank">
                        <img style="width: 100%;" src="https://cdn.newsfirst.lk/election/manifesto/sajith_e.png" alt="">
                        <div style="text-align: center;">
                            <button class="download_btn" mat-stroked-button>Download</button>
                        </div>
                    </a>
                </div>
                <div fxFlex="33" fxFlex.xs="100" fxFlex.sm="100" fxLayout="column">
                    <a href="https://cdn.newsfirst.lk/election/manifesto/Sajith_manifesto_tamil.pdf" target="_blank">
                        <img style="width: 100%;" src="https://cdn.newsfirst.lk/election/manifesto/sajith_t.png" alt="">
                        <div style="text-align: center;">
                            <button class="download_btn" mat-stroked-button>Download</button>
                        </div>
                    </a>
                </div>
            </div>
        </div>

         <!-- Namal -->
         <div style="margin-top: 10px;">
          <div fxLayout="row">
              <div class="black_header" style="width: max-content;padding-inline: 10px;">
                  <h2 class="black_header_title display-flex">Namal Rajapaksa</h2>
              </div>
          </div>
          <div fxLayout="row" fxLayoutGap="10" fxLayout.sm="column" fxLayout.xs="column">

              <div fxFlex="33" fxFlex.xs="100" fxFlex.sm="100" fxLayout="column">
                  <a href="https://cdn.newsfirst.lk/election/manifesto/Namal_manifesto_sin.pdf" target="_blank">
                      <img style="width: 100%;" src="https://cdn.newsfirst.lk/election/manifesto/namal_s.png" alt="">
                      <div style="text-align: center;">
                          <button class="download_btn" mat-stroked-button>Download</button>
                      </div>
                  </a>
              </div>
              <!-- <div fxFlex="33" fxFlex.xs="100" fxFlex.sm="100" fxLayout="column">
                  <a href="https://cdn.newsfirst.lk/election/manifesto/Sajith_manifesto_english.pdf" target="_blank">
                      <img style="width: 100%;" src="https://cdn.newsfirst.lk/election/manifesto/sajith_e.png" alt="">
                      <div style="text-align: center;">
                          <button class="download_btn" mat-stroked-button>Download</button>
                      </div>
                  </a>
              </div> -->
              <div fxFlex="33" fxFlex.xs="100" fxFlex.sm="100" fxLayout="column">
                  <a href="https://cdn.newsfirst.lk/election/manifesto/Namal__manifesto_tam.pdf" target="_blank">
                      <img style="width: 100%;" src="https://cdn.newsfirst.lk/election/manifesto/namal_t.png" alt="">
                      <div style="text-align: center;">
                          <button class="download_btn" mat-stroked-button>Download</button>
                      </div>
                  </a>
              </div>
          </div>
      </div>
    </div>
</div>
